import React, { useEffect, useRef, useState } from 'react';
import { Modal, Tag, Divider, message, Checkbox, Input, Button } from 'antd';
import './index.less';
import {
    backstageList, backstageInsDeal, backstageSearchWordPass
} from '../../../api/inspiration';
import WaterFall from '../../../component/WaterFall';
import copy from "copy-to-clipboard";
import { useCounter, useEventListener, useSetState, useLockFn } from 'ahooks';
let childWindow
const { confirm } = Modal;
const { TextArea } = Input;
message.config({
    top: 60,
    duration: 3,
    maxCount: 3,
});
const config = {
    maxPage: 10,
    pageSize: 25
}
const ClassifyAudit4Old = (props) => {
    const { location } = props

    const [detailList, setDetailList] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [oldSelectedIds, setOldSelectedIds] = useState([]);
    const [oldDetailListLength, setOldDetailListLength] = useState(0);
    const [classifyLoading, setClassifyLoading] = useState(false);
    const [info, setInfo] = useState({
        searchWordId: null,
        searchWord: '',
        attrWord: '',
        entityWord: ''
    })
    const [currentPage, { inc, dec, set, reset }] = useCounter(1, { min: 1, max: 10 });
    const [touchMax, setTouchMax] = useState(false)

    const [delModalVisible, setDelModalVisible] = useState(false)
    const [noPassModalVisible, setNoPassModalVisible] = useState(false)
    const [passModalVisible, setPassModalVisible] = useState(false)

    const [iv1, setIv1] = useState('')
    const [iv2, setIv2] = useState('')
    const [iv3, setIv3] = useState('')
    const [iv4, setIv4] = useState('')
    const [tv1, setTv1] = useState('')
    const [cbState, setCbState] = useSetState({
        cb1: false,
        cb2: false,
        cb3: false,
        cb4: false
    });

    const [ended,setEnded] = useState(false)

    const onChangeInput = (index, e) => {
        switch (index) {
            case 1:
                setIv1(e.target.value)
                break
            case 2:
                setIv2(e.target.value)
                break
            case 3:
                setIv3(e.target.value)
                break
            case 4:
                setIv4(e.target.value)
                break
            case 5:
                setTv1(e.target.value)
                break
        }
    }

    useEffect(()=>{
        childWindow = window.open('','classifyAudit4Old/old')
    },[])

    useEffect(() => {
        if (info.searchWordId) {
            if (!childWindow) {
                childWindow = window.open('','classifyAudit4Old/old')
            }
            childWindow.location.href = '#/inspiration/classifyAudit4Old/old?page=' + currentPage + '&searchWordId=' + info.searchWordId
        }
    }, [info.searchWordId])

    useEventListener('message', e => {
        switch (e.data.name) {
            case 'selectedIds':
                setOldSelectedIds(e.data.data)
                break
            case 'oldDetailListLength':
                setOldDetailListLength(e.data.data)
                updateEnded()
                break
            default:
                break
        }
    })

    useEventListener('keydown', useLockFn(async (e) => {
        if (noPassModalVisible) return
        switch (e.code) {
            case 'ArrowLeft':
                //上一屏
                goPrev()
                break
            case 'ArrowRight':
                //下一屏
                goNext()
                break
        }
    }))

    const goPrev = async () => {
        dec()
        setTouchMax(false)
    }

    const goNext = async () => {
        if (ended) {
            console.debug(touchMax)
            if (touchMax) {
                setTouchMax(false)
                await pass()
            } else {
                setTouchMax(true)
                message.warning('已经是最后一屏了，再点击就审核通过了哦')
            }
        } else {
            inc()
        }
    }

    const setCurrentData = () => {
        queryData()
        if (childWindow) {
            childWindow.postMessage({
                name: 'currentPage',
                data: currentPage
            })
        }
        updateEnded()
        setSelectedIds([])
    }

    useEffect(()=>{
        updateEnded()
    },[oldDetailListLength])

    useEffect(()=>{
        updateEnded()
    },[detailList])

    const updateEnded = () => {
        if ((currentPage != 1 && currentPage >= config.maxPage) || (detailList.length == 0 && oldDetailListLength == 0)) {
            setEnded(true)
        } else {
            setEnded(false)
        }
    }


    useEffect(() => {
        setCurrentData()
    }, [currentPage])

    const queryData = async () => {
        const res = await backstageList({ page: currentPage, type: 1, pageSize: config.pageSize });
        if (res?.error?.code == 0 && res.data) {
            setDetailList(res.data.inspirations ?? []);
            setInfo({
                searchWordId: res.data.searchWordId,
                searchWord: res.data.searchWord,
                attrWord: res.data.attrWord,
                entityWord: res.data.entityWord
            })
        } else {
            setDetailList([]);
        }
    }

    const click2copy = (e, insId) => {
        e.stopPropagation();
        if (copy(insId))
            message.success('复制成功')
        else
            message.error('复制失败')
    }

    function displayWaterFallRender(v) {
        return <div className='waterfall_tags_wrap'>
            <Tag color="magenta" onClick={(e) => click2copy(e, v.insId)}>{v.insId}</Tag>
        </div>
    }
    function onImgSelect(v, isSelect) {
    }

    const handleDelModalOk = () => {
        backstageInsDeal({
            searchWordId: info.searchWordId,
            newInsIdList: selectedIds
        }).then(res => {
            console.debug(res)
            if (res.error.code == 0) {
                message.destroy()
                message.success('删除成功');
            } else {
                message.error('删除失败');
            }
        }).catch(e => {
            console.debug(e)
            message.error('页面发生错误')
        }).finally(() => {
            setDelModalVisible(false)
        })
    }

    const handleNoPassModalOk = () => {
        const params = {
            attrReason: null,
            classifyReason: null,
            otherReason: null,
            qualityReason: null,
            searchWordId: info.searchWordId,
            subjectReason: null,
            type: 2,
            noPassScreen: currentPage
        }

        if (cbState.cb1) {
            params.classifyReason = iv1 || ''
        }
        if (cbState.cb2) {
            params.attrReason = iv2 || ''
        }
        if (cbState.cb3) {
            params.qualityReason = iv3 || ''
        }
        if (cbState.cb4) {
            params.subjectReason = iv4 || ''
        }
        params.otherReason = tv1 || ''

        backstageSearchWordPass(params).then(res => {
            if (res.error.code == 0) {
                setEnded(false)
                reset()
                if (currentPage==1) {
                    setCurrentData()
                }
                message.success('成功')
            } else {
                message.error('失败')
            }
        }).catch(e => {
            message.error('页面发生错误')
        }).finally(() => {
            handleModalCancel()
        })
    }

    const handlePassModalOk = () => {
        pass()
    }

    // 审核通过
    const pass = useLockFn(async () => {
        const params = {
            searchWordId: info.searchWordId,
            type: 1
        }
        message.loading('通过中', 0)
        handleModalCancel()
        await backstageSearchWordPass(params).then(res => {
            message.destroy()
            if (res.error.code == 0) {
                setEnded(false)
                message.success('成功')
                reset()
            } else {
                message.error('失败')
            }
        }).catch(e => {
            message.destroy()
            message.error('页面发生错误')
        })
    })

    const handleModalCancel = () => {
        setDelModalVisible(false)
        setNoPassModalVisible(false)
        setPassModalVisible(false)
        setCbState({
            cb1: false,
            cb2: false,
            cb3: false,
            cb4: false
        })
        setIv1('')
        setIv2('')
        setIv3('')
        setIv4('')
        setTv1('')
    }
    const onChange = (index, e) => {
        switch (index) {
            case 1:
                setCbState({ cb1: e.target.checked })
                break
            case 2:
                setCbState({ cb2: e.target.checked })
                break
            case 3:
                setCbState({ cb3: e.target.checked })
                break
            case 4:
                setCbState({ cb4: e.target.checked })
                break
        }
    }

    const selectAll = () => {
        let _arr = []
        if (selectedIds.length >= config.pageSize) {

        } else {

            detailList.forEach((item, index) => {
                _arr.push(item.insId)
            })
        }
        setSelectedIds(_arr)

    }

    return (
        <div className='cal_main'>
            <div className='top'>
                <div className='top_left'>
                    <span>图片搜索词：</span>
                    <Button>{info.searchWord}</Button>
                    <span>图片标签</span>
                    <div>
                        <Tag color="magenta">{info.entityWord}</Tag>
                        <Tag color="magenta">{info.attrWord}</Tag>
                    </div>
                </div>
                <div className='top_right'>
                    {/* <span>单屏</span> */}
                    <span>当前第{currentPage}屏</span>
                    <Button type="danger" onClick={() => {
                        if (selectedIds.length<=0) return message.warning('未选中任何图片')
                        // setDelModalVisible(true)
                        handleDelModalOk()
                    }}>删除</Button>
                    <Button onClick={() => setNoPassModalVisible(true)}>不通过</Button>
                    <Button onClick={() => selectAll()}>全选</Button>
                    <Button disabled={currentPage==1} onClick={()=> goPrev()}>上一屏</Button>
                    <Button disabled={ended} onClick={()=> goNext()}>下一屏</Button>
                    <Button disabled={!ended} onClick={() => setPassModalVisible(true)}>审核通过</Button>
                </div>
            </div>
            <div><Divider orientation="center">新图</Divider></div>
            <div className='imgList'>
                <WaterFall
                    list={detailList}
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                    displayRender={displayWaterFallRender}
                    onSelect={onImgSelect}
                    disabled={classifyLoading}
                />
            </div>
            <Modal
                title="删除"
                visible={delModalVisible}
                onOk={handleDelModalOk}
                onCancel={handleModalCancel}
                okText="确认"
                cancelText="取消">
                <p>确认删除?</p>
            </Modal>
            <Modal
                title='请输入不通过原因（可多选）'
                visible={noPassModalVisible}
                onOk={handleNoPassModalOk}
                okText='确定'
                onCancel={handleModalCancel}
                cancelText='取消'
                className='noPassModal'
                destroyOnClose={true}
            >
                <div className='noPassModalContent'>
                    <div>
                        <Checkbox onChange={e => onChange(1, e)} checked={cbState.cb1}>分类不准确</Checkbox>
                        <Input placeholder="请输入内容" value={iv1} onChange={(e) => onChangeInput(1, e)} />
                    </div>
                    <div>
                        <Checkbox onChange={e => onChange(2, e)} checked={cbState.cb2}>属性不准确</Checkbox>
                        <Input placeholder="请输入内容" value={iv2} onChange={(e) => onChangeInput(2, e)} />
                    </div>
                    <div>
                        <Checkbox onChange={e => onChange(3, e)} checked={cbState.cb3}>质量不合格</Checkbox>
                        <Input placeholder="请输入内容" value={iv3} onChange={(e) => onChangeInput(3, e)} />
                    </div>
                    <div>
                        <Checkbox onChange={e => onChange(4, e)} checked={cbState.cb4}>主体库有问题</Checkbox>
                        <Input placeholder="请输入内容" value={iv4} onChange={(e) => onChangeInput(4, e)} />
                    </div>
                    <div>
                        <span>其他原因</span>
                        <TextArea rows={4} cols={16} value={tv1} onChange={(e) => onChangeInput(5, e)} />
                    </div>
                </div>

            </Modal>

            <Modal
                title='审核通过'
                visible={passModalVisible}
                onOk={handlePassModalOk}
                okText='确定'
                onCancel={handleModalCancel}
                cancelText='取消'
            >
            </Modal>
        </div>
    )
}

export default ClassifyAudit4Old